import _ from 'lodash';

const namespaced = true;

const state = {
  reportId: null,
  report: {},
};

const mutations = {
  SET_REPORT_ID(state, reportId) {
    state.reportId = reportId;
  },
  SET_REPORT(state, report) {
    state.report = report;
  },
};

const actions = {
  async fetchReport({ commit, dispatch, state }) {
    if (!state.reportId) { return Promise.resolve(); }

    const report = await dispatch(`model/intervention/fetchReport`, state.reportId, { root: true });
    commit(`SET_REPORT`, report);

    return report;
  },
};

const getters = {
  report: state => {
    const report = {
      ...state.report,
      $sitePostalCodeAndCity: ``,
      $interventionHtmlDescription: ``,
    };
    if (report.id) {
      report.$interventionHtmlDescription = report.intervention.description.replace(/\r\n|\r|\n/g, `<br />`);
      const { site } = report.intervention;
      if (site) {
        report.$sitePostalCodeAndCity = _.trim(`${site.postalCode || ``} ${site.city || ``}`);
      }
    }

    return report;
  },
};

export default {
  namespaced, state, mutations, actions, getters,
};
